import { swSettings } from "app/common/services/swSettings";
import { FiltersEnum } from "app/components/filters-bar/utils";
import type { IRouterState } from "single-spa/react-app/router/IRouterState";
import CountryService from "app/services/CountryService";
import type { IFilterHandlerReturnObj, IParams } from "app/routes/handlers/filter-consistency/filterConsistencyUtils";

export const getCountryRequiredChanges = (
    componentConfigId: string | null,
    selectedCountry: string | number, // from the local storage-string, from the filter itself-number
    targetState: IRouterState,
    toParams: IParams,
): IFilterHandlerReturnObj => {
    const parsedCountry = +selectedCountry;
    const isUSStatesSupported = targetState.isUSStatesSupported;
    const isUsState = CountryService.isUSState(parsedCountry);
    const shouldChangeToDefaultCountry = isUsState && !isUSStatesSupported;

    const isFilterDisabled = targetState.data?.filtersConfig?.country === FiltersEnum.DISABLED;
    const isAllowed = swSettings.allowedCountry(parsedCountry, componentConfigId);

    const displayChangeIndicator =
        (!isAllowed || shouldChangeToDefaultCountry || (isFilterDisabled && parsedCountry !== +toParams.country)) &&
        !toParams.isCountryChanged;
    const isChanged = !isAllowed || isFilterDisabled || shouldChangeToDefaultCountry;
    const shouldChangeToSelected =
        parsedCountry !== +toParams.country && isAllowed && !shouldChangeToDefaultCountry && !isFilterDisabled;
    return {
        isAllowed,
        displayChangeIndicator,
        isChanged,
        shouldChangeToSelected,
    };
};
